const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
});

export default styles;
